<template>
    <div>
        <div class="type-btn" :class="{'type-btn-small': $vuetify.breakpoint.xs}">
            <v-btn-toggle 
                v-model="mapType" 
                mandatory 
                rounded 
                dense 
                borderless
                active-class="type-selected"
            >
                <v-btn small value="roadmap">
                    Mapa vial
                </v-btn>
                <v-btn small value="hybrid">
                    Satelital
                </v-btn>
            </v-btn-toggle>
        </div>
        <GmapMap
            ref="map"
            v-if="profile"
            :center="{
                lat: profile.location.latitude,
                lng: profile.location.longitude,
            }"
            :zoom="profile.map_zoom"
            :options="{
                zoomControl: false,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false,
            }"
            :map-type-id="mapType"
            class="map"
            @click="updateSelected(null)"
        >
            <div v-if="records && plants">
                <div :key="plant.id" v-for="plant in plants">
                    <GmapMarker
                        v-if="plant.location"
                        :position="{
                            lat: plant.location.latitude,
                            lng: plant.location.longitude,
                        }"
                        :icon="getIcon(plant.id)"
                        :ref="plant.id"
                        :clickable="true"
                        @click="updateSelected(plant.id)"
                    />
                </div>
            </div>
            
        </GmapMap>
        <div class="info-panel d-none d-sm-block" v-if="selected">
            <infoMeter 
                :gateway="plants.find(p => p.id == selected)" 
                :meters="getMeters(selected)" 
                :lastReadings="getLastReadings(selected)"
            />
        </div>
        <v-card class="info-panel-sm d-sm-none" v-if="selected">
            <infoMeter 
                :gateway="plants.find(p => p.id == selected)" 
                :meters="getMeters(selected)" 
                :lastReadings="getLastReadings(selected)"
            />
            <v-card-actions class="d-flex">
                <v-btn class="mx-auto" color="primary" @click="updateSelected(null)">Close</v-btn>
            </v-card-actions>
        </v-card>
        <div class="license">
            <a href="https://mapicons.mapsmarker.com/" >
                <img src="@/assets/map/license.gif" alt="license"  />
            </a>
        </div>
        
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import infoMeter from '../components/Plants/info'

export default {
    name: 'MapView',
    computed: {
        ...mapState({
            selected: state => state.gateways.selected,
            profile: (state) => state.account.profile,
            plants: (state) => state.gateways.list,
            records: (state) => state.meters.lastReadings
        }),
        ...mapGetters({ getMeters: 'meters/getMetersGtw' })
    },
    components: { infoMeter },
    data() {
        return {
            mapType: 'satellite'
        }
    },
    methods: {
        ...mapActions({ 
            updatedView: 'user/updatedView',
            updateSelected: 'gateways/updatedGatewaySelected'
        }),
        getIcon(plant) {
            let icon = {}
            let meters_measures = this.getLastReadings(plant)
            let plant_data = this.plants.find( p => p.id === plant )
            let type = this.profile.rates.find( r => r.name === plant_data.rate ).type

            if( plant == this.selected ) icon.scaledSize = { width: 41, height: 48 }
            if( meters_measures.length === 0 ){
                icon.url =  require(`@/assets/map/${type}-gray.png`)
                return icon
            } 
            
            let last_measure = { updated: null }
            meters_measures.forEach( measure => {
                if(last_measure.updated === null || measure.data.updated.getTime() > last_measure.updated.getTime())
                    last_measure = measure.data
            })
            
            if (last_measure) {
                const time = new Date().getTime() - new Date(last_measure.updated).getTime()
                const watts = last_measure.net_Kwh

                if( (this.profile.minutesToDanger * 60 * 1000) < time ) 
                    icon.url = require(`@/assets/map/${type}-red.png`) 

                else if( (this.profile.minutesToWarn * 60 * 1000) < time ) 
                    icon.url = require(`@/assets/map/${type}-yellow.png`) 

                else if( watts > this.profile.limitOff ) 
                    icon.url = require(`@/assets/map/${type}-green.png`) 
                
                else icon.url = require(`@/assets/map/${type}-white.png`) 
            }else{
                icon.url = require(`@/assets/map/${type}-gray.png`) 
            }
            
            return icon
        },
        getLastReadings(plant){
            const meters = this.getMeters(plant).map( m => m.id )
            if(!this.records) return
            return this.records.filter( r => meters.includes(r.meter) )
        },
        setCenter(){
            if(this.selected){
                const location = this.plants.find( p => p.id === this.selected ).location
                this.$refs.map.panTo({
                    lat: location.latitude,
                    lng: location.longitude + 0.001,
                })
            }
        }
    },
    watch: {
        selected(){
            this.setCenter()
        }
    },
    mounted(){
        this.updatedView('Map')
        this.setCenter()
    }
}
</script>

<style scoped>
.h-100{
    height: 100%;
}
.map {
    display: contents;
}
.back{
    position: absolute;
    top: 10px;
    left: 10px;
}
.license {
    position: absolute;
    bottom: 19px;
    z-index: 2;
}
.type-btn{
    position: absolute;
    top: 10px;
    z-index: 2;
}
.type-btn-small{
    top: 60px !important;
}
.v-btn:before{
    opacity: 0 !important;
}
.type-selected{
    color: var(--v-accent-base) !important;
    background-color: white !important;
}
.info-panel{
    z-index: 1000;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    width: 25vw;
}
.info-panel-sm{
    z-index: 1000;
    height: 70vh;
    margin-top: 55px;
    margin-right: auto;
    margin-left: auto;
}
.close{
    position: absolute;
    right: 1px;
    top: 10px;
    z-index: 2;
}
</style>
